import Link from 'next/link';
import { RegionSettings } from '../../data/api';
import styles from '../../styles/RegionHeader.module.scss';
import Icon from '../Icon';
import LinearUnitSelector from '../LinearUnitSelector';
interface HeaderProps {
    settings: RegionSettings;
}

function RegionHeader({ settings }: HeaderProps) {
    return (
        <header className={styles.header}>
            <div className={styles.logos}>
                <Link href="/">
                    <a className={styles.link} rel="noopener">
                        <img
                            alt="Ride Report"
                            src="/logo-on-light.svg"
                            className={styles.logo}
                        />
                        <span className={styles.bar} />
                    </a>
                </Link>
                <div className={styles.breadcrumbContainer}>
                    <Link href="/">
                        <a className={styles.link} rel="noopener">
                            Micromobility Dashboard
                            <Icon
                                icon="Breadcrumb"
                                className={styles.breadcrumb}
                            />
                        </a>
                    </Link>
                    <span>{settings.name}</span>
                </div>
            </div>
            <div className={styles.rightSideControls}>
                <div className={styles.linearUnitSelector}>
                    <LinearUnitSelector></LinearUnitSelector>
                </div>
            </div>
        </header>
    );
}

export default RegionHeader;
